import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

const lineKey = (itemId, variant) => (variant ? `${itemId}::${variant}` : itemId);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("fichaje_carta_cart")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("fichaje_carta_cart", JSON.stringify(items));
  }, [items]);

  // product: {id, name}, variant: {name, price} | null
  const add = (product, variant = null) => {
    const key = lineKey(product.id, variant?.name);
    const price = variant ? variant.price : product.price;
    const name = product.name;
    setItems((prev) => {
      const found = prev.find((i) => i.key === key);
      if (found) {
        return prev.map((i) => (i.key === key ? { ...i, quantity: i.quantity + 1 } : i));
      }
      return [
        ...prev,
        { key, item_id: product.id, name, variant: variant?.name || "", price, quantity: 1 },
      ];
    });
  };

  const remove = (key) => setItems((prev) => prev.filter((i) => i.key !== key));

  const updateQty = (key, qty) => {
    if (qty <= 0) {
      remove(key);
      return;
    }
    setItems((prev) => prev.map((i) => (i.key === key ? { ...i, quantity: qty } : i)));
  };

  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);

  const value = useMemo(
    () => ({ items, add, updateQty, remove, clear, count, total, open, setOpen }),
    [items, count, total, open] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
